export default class CompareTo {
  constructor() {
    'ngInject';

    this.require = 'ngModel';
    this.restrict = 'A';
    this.scope = {
      otherModelValue: '=compareTo'
    };
  }

  link($scope, element, attrs, ctrl) {
    $scope.$watch('otherModelValue', () => {
      ctrl.$validate();
    });

    ctrl.$validators.compareTo = modelValue =>
      modelValue === $scope.otherModelValue;
  }

  static directiveFactory() {
    'ngInject';

    return new CompareTo();
  }
}



// WEBPACK FOOTER //
// ./common/directives/validation/compare-to.js